export const emptyPlatoForm = () => ({
    nombre: "",
    descripcion: "",
    nombre_en: "",
    descripcion_en: "",
    alergenosIds: [],
});

export const platoToForm = (plato) => ({
    nombre: plato?.nombre || "",
    descripcion: plato?.descripcion || "",
    nombre_en: plato?.nombre_en || "",
    descripcion_en: plato?.descripcion_en || "",
    alergenosIds: Array.isArray(plato?.alergenos) ? plato.alergenos.map((a) => a.id) : [],
});
